module.exports = __webpack_public_path__ + "img/main_3_2_2.16a354f3.png";